import i18next from "../../i18n";
import { useReadFile } from "../../hooks";
import { Download } from "@carbon/icons-react";

const FileReader = ({ fileKey, text }: { fileKey: string; text?: string }) => {
  const { mutate: readFile, isPending } = useReadFile();

  return (
    <button
      className="px-2 py-1 bg-spectum text-white hover:bg-spectum-light flex justify-center items-center gap-2 text-xxs font-medium rounded focus:outline-none focus:ring-2 focus:ring-offset-2 uppercase"
      disabled={isPending}
      onClick={() => readFile(fileKey)}
    >
      <Download size={16} aria-hidden="true" />
      {text ? text : i18next.t("cta.download")}
    </button>
  );
};

export default FileReader;
